
export const getToastOpt = (object) => {
  if (object.duration === undefined) object.duration = 3000;
  if (object.isClosable === undefined) object.isClosable = true;
  if (object.position === undefined) {
    // Centered
    object.position = 'top';
    object.containerStyle = {
      marginTop: "40vh", 
      textAlign: "center",
    };
  }  
  return object;
}

export const isMobileDevice = () => {
  const userAgentCheck = /Mobi|Android/i.test(navigator.userAgent);
  const isNarrowScreen = window.innerWidth <= 1200;
  const isPortrait = window.innerHeight > window.innerWidth;
  return userAgentCheck || isNarrowScreen || isPortrait;
}

export const getBaseUrl = () => {
  const { protocol, hostname, port } = window.location;
  return `${protocol}//${hostname}${port ? `:${port}` : ''}`;
}

export const isLocalhostOrHttps = () => {
  const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
  const isHttps = window.location.protocol === 'https:';
  return isLocalhost || isHttps;
}

export const sleep = (ms) => {
  return new Promise(resolve => setTimeout(resolve, ms));
}
